// extracted by mini-css-extract-plugin
export default {"zoomModal":"S0-z"};